(ns ycweb.app.website.dlp.widgets.huntcompetition
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.core :as u]
   [ycweb.util.date :as yud]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc hunt-competition < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:hunt-competition/keys
         [title title-pre-text title-sub-title main-text
          demo-icon-public-id competition-is-closed
          closed-title closed-main-text scroll-down-button
          popup-header-public-id help-article terms-and-cond
          riddles-idx open-button hunt-name target-page-url]} properties

        last-riddle (last (vals riddles-idx))
        hunt-end-date (:riddles/date-to last-riddle)
        hunt-start-date (:riddles/date-from (first (vals riddles-idx)))
        now (dt/plus (dt/now) (dt/hours 2))]

    [:<>
     [:div
      {:class (u/bem :yc-section [:medium])}
      (cond
        (or
          competition-is-closed
          (dt/after? now hunt-end-date))
        [:div.yc-intro-text
         (headings/heading closed-title
           {:type :h1 :size :large :center true})
         [:div
          {:dangerouslySetInnerHTML
           {:__html (or closed-main-text "")}}]
         [:div.u-block-center.u-max-width-240.u-margin-top-30
          (buttons/button-web "Shop our Range"
            (merge
              (urlstate/href-props app-atom "index" "")
              {:style :primary
               :full true
               :icon :cart}))]]

        :else
        [:div.yc-intro-text
         (headings/heading title
           {:type :h1
            :size :large
            :center true
            :pretext title-pre-text
            :subtext title-sub-title})
         [:div.u-block-center.u-max-width-180.u-margin-bottom-20
          (web-common/lazy-image app-atom
            demo-icon-public-id
            {:class "yc-simple-image  yc-simple-image--full"}
            {:q "auto"})]
         [:div.u-margin-bottom-24
          {:dangerouslySetInnerHTML
           {:__html (or main-text "")}}]

         (when
           (and
             (dt/after? now hunt-start-date)
             (dt/before? now hunt-end-date))
           [:div.u-block-center.u-max-width-240
            (buttons/button-web
              (cond
                scroll-down-button
                scroll-down-button

                :else
                "Get Today's Clue")
              (merge
                (urlstate/href-on-click #(scroll/scroll-to-id % "hunt-clues"))
                {:style :secondary
                 :full true}))])])]

     [:div
      {:class (u/bem :yc-section [:medium])
       :id "hunt-clues"}
      (headings/heading
        (cond
          (dt/before? now hunt-start-date)
          (str "Check back on " (yud/format-date hunt-start-date "d MMMM") " for the first clue below")

          (and
            (dt/after? now hunt-start-date)
            (dt/before? now hunt-end-date))
          "Check back each day for a new clue below"

          :else
          "Solutions for this year's clues below")
        {:type :h2
         :size :small
         :center true})

      (into
        [:div.flex-grid-group]
        (map
          (fn [[idx whole-riddle]]
            (let [{:riddles/keys
                   [riddle riddle-answer date-from date-to product-id
                    coming-soon-public-id closed-public-id open-public-id
                    riddle-image-answer-public-id riddle-image-public-id]} whole-riddle]

              (when
                (and product-id
                  (or
                    (and riddle riddle-answer)
                    (and riddle-image-public-id riddle-image-answer-public-id)))
                [:div
                 {:class (u/bem :flex-grid-block [:t-1-2 (str "l-1-" (count riddles-idx))])}
                 [:div.flex-grid-content
                  (cond
                    (or
                      competition-is-closed
                      (dt/after? now date-to))
                    [:a.hunt-clue.u-block-link
                     (urlstate/href-on-click
                       #(grid/open-modal app-atom :web.hunt-competition/answer
                          {:whole-riddle whole-riddle
                           :popup-header popup-header-public-id
                           :idx idx}))
                     (web-common/lazy-image app-atom
                       closed-public-id
                       {:class (u/bem :yc-simple-image [:full])}
                       {:q "auto"
                        :alt (str "Clue " (inc idx) " Closed")})
                     [:span.hunt-clue__button-wrapper
                      (buttons/button-web
                        [:span [:span.clip-text.unclip-text--s "View"] " Answer"]
                        {:type :span-button
                         :style :secondary
                         :full true})]
                     [:span.hunt-clue__footnote "Entries Closed"]]

                    (dt/before? now date-from)
                    [:div.hunt-clue.u-block-link
                     (web-common/lazy-image app-atom
                       coming-soon-public-id
                       {:class (u/bem :yc-simple-image [:full])}
                       {:q "auto"
                        :alt (str "Clue " (inc idx) " Coming Soon")})
                     [:span.hunt-clue__button-wrapper
                      (buttons/button-web "Coming soon"
                        {:type :span-button
                         :style :secondary
                         :full true})]
                     [:span.hunt-clue__footnote
                      (str "Coming " (yud/format-date (:riddles/date-from whole-riddle) "dd MMMM"))]]

                    :else
                    [:a.hunt-clue.u-block-link
                     (urlstate/href-on-click
                       #(grid/open-modal app-atom :web.hunt-competition/riddle
                          {:whole-riddle whole-riddle
                           :popup-header popup-header-public-id
                           :target-url (str target-page-url "?ref=" (str/replace hunt-name #" " ""))}))
                     (web-common/lazy-image app-atom
                       open-public-id
                       {:class (u/bem :yc-simple-image [:full])}
                       {:q "auto"
                        :alt (str "Clue " (inc idx) " Open")})
                     [:span.hunt-clue__button-wrapper
                      (buttons/button-web
                        (cond
                          (= open-button "read riddle")
                          [:span "Read"
                           [:span.clip-text.unclip-text--s " Riddle"]]

                          :else
                          [:span "View"
                           [:span [:span.clip-text.unclip-text--s " Clue"]]])

                        {:type :span-button
                         :style :primary
                         :full true})]
                     [:span.hunt-clue__footnote "Open 'til midnight"]])]])))
          riddles-idx))]

     (when
       (and
         (dt/after? now hunt-start-date)
         (dt/before? now hunt-end-date))
       [:div
        {:class (u/bem :yc-section [:large])}
        [:p.u-text-center.u-margin-top-30
         {:class (u/bem :yc-paragraph [:flush])}
         "Still not sure how to play? "
         [:a.js-mfp-open-url
          {:href (str "/" help-article)
           :class (u/bem :text-link [:muted])
           :target_url (str "/" help-article "&overrideincludes=blank")
           :data-title "How Do Riddle Hunts Work?"
           :data-content-wrapper-class "yc-simple-text"}
          "Read how our Hunt Competitions work."]]
        [:p.yc-paragraph.u-text-center.u-margin-top-8
         [:a.js-mfp-open-url
          {:href (str "/" terms-and-cond)
           :class (u/bem :text-link [:muted])
           :target_url (str "/" terms-and-cond "&overrideincludes=blank")
           :data-title hunt-name
           :data-content-wrapper-class "yc-simple-text"}
          "Terms & Conditions"]]])]))

(rum/defc hunt-riddle-popup-body < rum/reactive [app-atom config-atom]
  (let [whole-riddle (cmn/curact config-atom :whole-riddle)
        popup-header (cmn/curact config-atom :popup-header)
        {:riddles/keys [riddle-title riddle-image-public-id riddle]} whole-riddle
        target-url (cmn/curact config-atom :target-url)]

    [:div
     {:class (u/bem :yc-popup [:hunt])}
     (when popup-header
       (web-common/lazy-image app-atom
         popup-header
         {:class (u/bem :yc-simple-image [:full :s-margin] :hunt-pop-graphic)}
         {:q "auto"
          :alt ""}))
     (headings/heading riddle-title
       {:type :h2
        :size :small
        :center true})
     (when riddle-image-public-id
       [:div.u-block-center.u-max-width-490.u-margin-bottom-20
        (web-common/lazy-image app-atom
          riddle-image-public-id
          {:class ["yc-simple-image  yc-simple-image--full"]}
          {:w 490
           :mw 490
           :q "auto"})])
     (when riddle
       [:div.u-text-center.hunt-clue__riddle-wrapper.yc-simple-text
        {:dangerouslySetInnerHTML
         {:__html riddle}}])
     [:div.u-text-center
      (buttons/button-web "Start Hunting"
        {:style :primary
         :href target-url})]]))

(defmethod grid/modal-config :web.hunt-competition/riddle [_ _ _]
  {:body hunt-riddle-popup-body
   :modal-type :variable})

(rum/defc hunt-answer-popup-body < rum/reactive [app-atom config-atom]
  (let [whole-riddle (cmn/curact config-atom :whole-riddle)
        {:riddles/keys
         [riddle-answer product-name riddle-image-answer-public-id]}
        whole-riddle
        popup-header (cmn/curact config-atom :popup-header)]

    [:div
     {:class (u/bem :yc-popup [:hunt])}
     (web-common/lazy-image app-atom
       popup-header
       {:class (u/bem :yc-simple-image [:full :s-margin])}
       {:q "auto"
        :alt ""})
     (headings/heading product-name
       {:type :h2
        :size :small
        :center true
        :pretext (str "Day " (inc (:idx whole-riddle)) " Answer")})
     (when
       riddle-image-answer-public-id
       [:div.u-block-center.u-max-width-490.u-margin-bottom-20
        (web-common/lazy-image app-atom
          riddle-image-answer-public-id
          {:class ["yc-simple-image  yc-simple-image--full"]}
          {:w 490
           :mw 490
           :q "auto"})])
     (when
       riddle-answer
       [:div.u-text-center.hunt-clue__answer-wrapper
        {:dangerouslySetInnerHTML
         {:__html riddle-answer}}])]))

(defmethod grid/modal-config :web.hunt-competition/answer [_ _ _]
  {:body hunt-answer-popup-body
   :modal-type :variable})